import fileUploaderComponent from './fileUploader.component';
import fileItemModule from './fileItem/fileItem';

const fileUploaderModule = angular.module('app.common.ertFileUploader', [fileItemModule])
	.component('ertFileUploader', fileUploaderComponent)
	.name;

export default fileUploaderModule;

